import { VF_PARAGRAPH } from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';

const fieldId = 'paragraph-comm-required';

const validator = () => null;

const vFParams = {
  paragraph: `Note: Comms are required for CRQs that impact customers services. Selecting ${'No'} will mean Comms are not issued and may lead to a breach in Vodafone's contractual obligations.`,
};

const paragraphCommRequired = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_PARAGRAPH,
};

export { paragraphCommRequired };
